import fetchWithCache from './fetchWithCache';
import { fetchJSON } from '@bonnet/next/fetch';

const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const fetchMakeSiteMap = () => fetchJSON('/car-dealers/sitemaps/kbb_make_dealers.json');

export default async function getValidSeoMakesFromSiteMap() {
    let seoMakesFromSiteMap = null;

    try {
        seoMakesFromSiteMap = await fetchWithCache(fetchMakeSiteMap, null, 'sitemapMakes_kbb', CACHE_TTL);
    } catch (error) {
        return [];
    }

    const validSeoMakesFromSiteMap = [];

    if (seoMakesFromSiteMap?.urls?.length > 0) {
        seoMakesFromSiteMap.urls.forEach((url) => {
            const data = url.split('/').filter((part) => part !== '');
            const make = data[data.length - 1];

            validSeoMakesFromSiteMap.push(make);
        });
    }

    return validSeoMakesFromSiteMap;
}
